import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=10c1ef47&"
import script from "./user-card.vue?vue&type=script&lang=js&"
export * from "./user-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports